import { gql } from '@apollo/client';

export const GET_MY_FIELD_SESSION_SUMMARY_QUERY = gql`
  query GetMyFieldSessionSummaryQuery($id: ID!) {
    getMyFieldSession(id: $id) {
      id
      clientId
      createdAt
      updatedAt
      startedAt
      endedAt
      siteId
      siteName
      name
      note
      activeDurationSeconds
      distanceMeters
      findCount
      track
    }
  }
`;
